// The code in this file will load on every page of your site

$w.onReady(function () {
	// <script id="mcjs">!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/499f57d457873efc3553678bb/61efb16b62ca1b659baa448d2.js");</script>
});